import {
  customElement,
  DeesElement,
  property,
  html,
  cssManager,
  unsafeCSS,
  css,
  TemplateResult,
} from '@design.estate/dees-element';

@customElement('philkunz-header')
export class PhilkunzHeader extends DeesElement {
  @property()
  public someProperty = 'someProperty';

  constructor() {
    super();
  }

  public static styles = [
    cssManager.defaultStyles,
    css`
      :host {
        position: relative;
        display: block;
        background: ${cssManager.bdTheme('#eeeeeb', '#000000')};
        display: block;
        height: 600px;
        border-bottom: 1px solid;
        border-image: radial-gradient(circle, #88888840, #88888800) 1;
      }
      :host([hidden]) {
        display: none;
      }

      .headerMain {
        color: #fff;
        position: relative;
        overflow: hidden;
        margin: auto;
        max-width: 1400px;
        height: 600px;
        background: url('/assets/profile.jpg') no-repeat center center;
        background-size: cover; /* Ensures the image fills the container */
        will-change: transform;
      }

      .shadowTop {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 50%;
        background: ${cssManager.bdTheme('linear-gradient(to bottom, #eeeeeb 0%, #eeeeeb00 20%)', 'linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%)')};
      }
      .shadowCircular {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background: ${cssManager.bdTheme('radial-gradient( circle, #eeeeeb00 20%, #eeeeeb 90% )', 'radial-gradient( circle,rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 90% )')}
      }

      ${cssManager.cssForNotebook(css`
        .headerMain {
          color: #fff;
          position: relative;
          max-width: 1200px;
          overflow: hidden;
          margin: auto;
          padding-left: 24px;
          padding-right: 24px;
        }
      `)}

      .logo {
        padding: 20px;
        position: absolute;
        bottom: 20px;
        left: calc(50% - 70px);
        display: block;
        height: 140px;
        width: 140px;
        filter: ${cssManager.bdTheme('invert(0) brightness(93%) sepia(5%)', 'invert(1)')};
        border: 8px solid #00000020;
        border-radius: 50%;
        background: #ffffff;
        will-change: transform;
      }
    `,
  ];

  public render(): TemplateResult {
    return html`
      <style></style>
      <div class="headerMain">
        <div class="shadowTop"></div>
        <div class="shadowCircular"></div>
        <embed
          class="logo"
          src="https://assetbroker.lossless.one/websites/philkunz.com/logo-philkunz.svg"
        />
      </div>
    `;
  }

  public async firstUpdated(_changedProperties) {
    const domtoolsInstance = await this.domtoolsPromise;
    await super.firstUpdated(_changedProperties);
    const headerMain: HTMLElement = this.shadowRoot.querySelector('.headerMain');
    const logo: HTMLElement = this.shadowRoot.querySelector('.logo');
    domtoolsInstance.scroller.onScroll(async () => {
      const scrollTop = document.documentElement.scrollTop;
      if (scrollTop < 640) {
        headerMain.style.transform = `translateY(${scrollTop/2}px)`;
        logo.style.transform = `translateY(${scrollTop/10}px)`;
      }
    });
  }
}
